import API from '@/lib/API.js'
import comun from './comun.js'
const autorizaciones = {
  namespaced: true,
  state: {
    Lista: [],
    ListaPorAfiliado: [],
    Paginas: 0,
    ListaPorArea: [],
    ListaPorEfector: [],
    Seleccionado: undefined,
    Filtros: ''
    ,
    Cantidades: ''
  },
  mutations: {
    init(state) {
      state = {
        Lista: [],
        ListaPorAfiliado: [],
        Paginas: 0,
        ListaPorArea: [],
        Seleccionado: undefined,
        Cantidades: ''
      }
    },
    set(state, valor) {
      state.Lista = valor
    },
    setPorAfiliado(state, valor) {
      state.ListaPorAfiliado = valor
    },
    setPorArea(state, valor) {
      state.ListaPorArea = valor
    },
    setPorEfector(state, valor) {
      state.ListaPorEfector = valor
    },
    setPaginas(state, valor) {
      state.Paginas = valor
    },
    setCantidades(state, valor) {
      state.Cantidades = valor
    },
    agregar(state, valor) {
      state.Lista.push(valor)
    },
    select(state, valor) {
      state.Seleccionado = valor
    },
    setFiltros(state, valor) {
      state.Filtros = valor
    },
    resetFiltros(state) {
      state.Filtros = ''
    }
  },
  actions: {
    async traerPorAfiliado({ commit }, valor) {
      commit('comun/cargando')
      let data = []
      data = await API.Autorizaciones.traerPorAfiliado(valor)
      commit('setPorAfiliado', data)
      commit('comun/fincarga')
    },
    async traerPorAfiliadoyEfector({ commit }, valor) {
      let data = []
      data = await API.Autorizaciones.traerPorAfiliadoyEfector(
        valor.id_afiliado,
        valor.id_efector
      )
      commit('setPorAfiliado', data)
    },
    async traerPorArea({ commit }, valor) {
      //commit("comun/cargando")
      let data = []
      data = await API.Autorizaciones.traerPorArea(valor)
      commit('setPorArea', data)
      //commit("comun/fincarga")
    },
    async traerPorAreaPaginado({ commit, state }, valor) {
      commit('comun/cargando')
      let data = []
      let filtros = state.Filtros
      data = await API.Autorizaciones.traerPorAreaPaginado(
        valor.id_area,
        valor.pagina,
        filtros.filtroTipo,
        filtros.filtroid_solic,
        filtros.filtroafiliado,
        filtros.filtropractica,
        filtros.filtroefector,
        filtros.filtroconvenio,
        filtros.filtroprovincia,
        filtros.filtroplan
      )
      commit('setPorArea', data.Datos.Autorizaciones)
      commit('setCantidades', data.Datos.Cantidades)
      commit('setPaginas', data.Cantidad)
      commit('comun/fincarga')
    },
    async traerPorEfector({ commit }, valor) {
      //commit("comun/cargando")
      let data = []
      data = await API.Autorizaciones.traerPorEfector(valor)
      commit('setPorEfector', data)
      //commit("comun/fincarga")
    },
    select({ commit }, valor) {
      commit('select', valor)
      commit('set', [])
    },
    setFiltros({ commit }, valor) {
      commit('setFiltros', valor)
    },
    resetFiltros({ commit }) {
      commit('resetFiltros')
    },
    async modificarSeleccionada({ commit, state }) {
      try {
        let data = []
        let str = ''
        if (state.Seleccionado.id_solic != 0) {
          data = await API.Autorizaciones.modificar(state.Seleccionado)
          str += 'Autorizacion modificada'
        } else {
          data = await API.Autorizaciones.alta(state.Seleccionado)
          commit('agregar', data)
          str += `Autorizacion dada de alta`
        }
        commit('select', data)
        commit('comun/mostrar', str)
      } catch (error) {
        alert(error)
      }
    },
    async modificarEntidad({ commit, state }, entidad) {
      try {
        let str = ''
        if (entidad.id_solic != 0) {
          entidad = await API.Autorizaciones.modificar(entidad)
          str += 'Autorizacion modificada'
        } else {
          entidad = await API.Autorizaciones.alta(entidad)
          commit('agregar', entidad)
          str += `Autorizacion dada de alta`
        }
        commit('comun/mostrar', str)
        return entidad
      } catch (error) {
        alert(error)
      }
    }
  },
  modules: {
    comun
  }
}
export default autorizaciones
